import type { FC } from 'react'
import { useMemo } from 'react'
import type { GetStaticProps } from 'next'
import type { DehydratedState } from '@tanstack/react-query'
import { QueryClient, dehydrate } from '@tanstack/react-query'

import CustomerSuccessEventsView from 'views/CustomerSuccessEvents'

import { createClient } from '@segment/api/staticSiteBackend/client'

import {
  createFeaturedEventQuery,
  createFetchEventsQuery,
  createFiltersQuery,
} from '@segment/api/routes/customerSuccessEvent/queries'

import { createStaticSiteBackend, StaticSiteBackendProvider } from '@segment/contexts/staticSiteBackend'

const EventsCustomerSuccess: FC = () => {
  const staticSiteBackend = useMemo(() => createStaticSiteBackend(), [])
  return (
    <StaticSiteBackendProvider value={staticSiteBackend}>
      <CustomerSuccessEventsView />
    </StaticSiteBackendProvider>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const queryClient = new QueryClient()
  const client = createClient()

  await queryClient.prefetchQuery(...createFiltersQuery(client))
  const filters = Object.keys(await queryClient.fetchQuery(...createFiltersQuery(client))).reduce(
    (acc, key) => ({ ...acc, [key]: [] }),
    {}
  )
  await queryClient.prefetchQuery(...createFetchEventsQuery(client, { filters }))
  await queryClient.prefetchQuery(...createFeaturedEventQuery(client))

  const dangerousDehydratedState = dehydrate(queryClient)

  const safeDehydratedState: DehydratedState = JSON.parse(JSON.stringify(dangerousDehydratedState))

  const props = {
    dehydratedState: safeDehydratedState,
  }

  return {
    props,
  }
}

export default EventsCustomerSuccess
